import { PaletteMode } from '@mui/material';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'src/redux/store';
import { SupportedLocales } from 'src/services/language-service';
export interface ThemeState {
    paletteMode: PaletteMode;
    locale: SupportedLocales;
}

const initialState: ThemeState = {
    paletteMode: 'dark',
    locale: 'roRO',
};

export const getPaletteMode = (isDarkMode: boolean): PaletteMode => (isDarkMode ? 'dark' : 'light');

const themeSlice = createSlice({
    name: 'reports',
    initialState,
    reducers: {
        setPaletteMode: (state, action: PayloadAction<PaletteMode>) => {
            state.paletteMode = action.payload;
        },
        togglePaletteMode: (state) => {
            state.paletteMode = getPaletteMode(state.paletteMode === 'light');
        },
        setLocale: (state, action: PayloadAction<SupportedLocales>) => {
            state.locale = action.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const themeActions = {
    ...themeSlice.actions,
};

export default themeSlice.reducer;

export const themeSelectors = {
    paletteMode: (state: RootState) => state.theme.paletteMode,
    locale: (state: RootState) => state.theme.locale,
    all: (state: RootState) => state.theme,
};
